import logo from './logo.svg';
import jordan from './assets/IMG_0394.jpg';
import mainLogo from './assets/JORDAN LOGO FULL.png';
import plants from './assets/6V3A8008.jpg';
import adjustment from './assets/IMG_0393.jpg';
import estim from './assets/estim.jpg';
import cupping from './assets/cupping.jpg';
import portrait2 from './assets/jordan-portrait-2.jpg';
import React, { useEffect, useRef, ReactElement } from "react";
import ReactDOM from "react-dom";
import './App.css';
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import emailjs from '@emailjs/browser';
import { useState } from 'react';


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link, useLocation
} from 'react-router-dom';


function App() {

  const [style, setStyles] = useState({display: "none"});

  const menuClick = () => {
    setStyles(
      {
        display: "block",
        animationName: "menuOpen",
        animationDuration: "1s",
        zIndex: 2
      });
  };

  const xClick = () => {
    setStyles(
      {
        animationName: "menuClose",
        animationDuration: "1s",
        animationFillMode: "forwards"
      });
  };
  
    
  return (
    <div className="App">
      <header className="App-header">
      </header>
      <Router>
        <div id="navbar">
          <nav>
            <img id="main-logo" src={mainLogo} />
            <ul id="menu" className="nav">
              <li>
                <CurrentLink name="Home" to="/"/>
              </li>
              <li id="about">
                <CurrentLink name="About" to="/about"/>
              </li>
              <li id="contact">
                <CurrentLink name="Contact" to="/contact"/>
              </li>
              <li id="services">
                <CurrentLink name="Services" to="/services"/>
              </li>
            </ul>
            <div id="menu-icon-div" onClick={() => menuClick()}>
              <svg id="menu-icon" enableBackground="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
                <path d="m128 102.4c0-14.138 11.462-25.6 25.6-25.6h332.8c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-332.8c-14.138 0-25.6-11.463-25.6-25.6zm358.4 128h-460.8c-14.138 0-25.6 11.463-25.6 25.6 0 14.138 11.462 25.6 25.6 25.6h460.8c14.138 0 25.6-11.462 25.6-25.6 0-14.137-11.462-25.6-25.6-25.6zm0 153.6h-230.4c-14.137 0-25.6 11.462-25.6 25.6 0 14.137 11.463 25.6 25.6 25.6h230.4c14.138 0 25.6-11.463 25.6-25.6 0-14.138-11.462-25.6-25.6-25.6z"/>
              </svg>
            </div>
          </nav>
        </div>
        <div style={style} id="side-menu">
          <div id="close-div" onClick={() => xClick()}>
            <svg id="close" enableBackground="new 0 0 320.591 320.591" height="512" viewBox="0 0 320.591 320.591" width="512" xmlns="http://www.w3.org/2000/svg">
              <g>
                <g id="close_1_">
                  <path d="m30.391 318.583c-7.86.457-15.59-2.156-21.56-7.288-11.774-11.844-11.774-30.973 0-42.817l257.812-257.813c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875l-259.331 259.331c-5.893 5.058-13.499 7.666-21.256 7.288z"/>
                  <path d="m287.9 318.583c-7.966-.034-15.601-3.196-21.257-8.806l-257.813-257.814c-10.908-12.738-9.425-31.908 3.313-42.817 11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414-6.35 5.522-14.707 8.161-23.078 7.288z"/>
                </g>
              </g>
            </svg>
          </div>
          <ul id="side-menu-options" className="nav">
            <li>
              <CurrentLink name="Home" to="/"/>
            </li>
            <li id="about">
              <CurrentLink name="About" to="/about"/>
            </li>
            <li id="contact">
              <CurrentLink name="Contact" to="/contact"/>
            </li>
            <li id="services">
              <CurrentLink name="Services" to="/services"/>
            </li>
          </ul>
      </div>
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          
          <Route path="/services" >
            <Services />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        
        <div id="footer" className="footer">
          <div id="footer-logo-div">
            <img id="footer-logo" src={mainLogo} />
          </div>
          
          <ul id="footer-menu">
            <li id="menu-title">
              Menu
            </li>
            <li>
              <CurrentLink name="Home" to="/"/>
            </li>
            <li id="about">
              <CurrentLink name="About" to="/about"/>
            </li>
            <li id="contact">
              <CurrentLink name="Contact" to="/contact"/>
            </li>
            <li id="services">
              <CurrentLink name="Services" to="/services"/>
            </li>
          </ul>
          <ul id="footer-contact">
            <li>
              Contact
            </li>
            <li>
              4028 Long Beach Blvd Suite 202
            </li>
            <li>
              Long Beach, CA 90807
            </li>
            <li>
              United States
            </li>
          </ul>
          <div id="social-media">
              <div id="instagram-svg-div">
                <a href="https://www.instagram.com/dr.jordan.dc/">
                  <svg id="instagram-svg" viewBox="0 0 511 511.9" xmlns="http://www.w3.org/2000/svg">
                      <path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0"/>
                      <path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"/><path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"/>
                  </svg>
                </a>
              </div>
              <div id="tiktok-svg-div">
                <a href="https://www.tiktok.com/@dr.jordan.dc">
                  <svg id="tiktok-svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path d="m480.32 128.39c-29.22 0-56.18-9.68-77.83-26.01-24.83-18.72-42.67-46.18-48.97-77.83-1.56-7.82-2.4-15.89-2.48-24.16h-83.47v228.08l-.1 124.93c0 33.4-21.75 61.72-51.9 71.68-8.75 2.89-18.2 4.26-28.04 3.72-12.56-.69-24.33-4.48-34.56-10.6-21.77-13.02-36.53-36.64-36.93-63.66-.63-42.23 33.51-76.66 75.71-76.66 8.33 0 16.33 1.36 23.82 3.83v-62.34-22.41c-7.9-1.17-15.94-1.78-24.07-1.78-46.19 0-89.39 19.2-120.27 53.79-23.34 26.14-37.34 59.49-39.5 94.46-2.83 45.94 13.98 89.61 46.58 121.83 4.79 4.73 9.82 9.12 15.08 13.17 27.95 21.51 62.12 33.17 98.11 33.17 8.13 0 16.17-.6 24.07-1.77 33.62-4.98 64.64-20.37 89.12-44.57 30.08-29.73 46.7-69.2 46.88-111.21l-.43-186.56c14.35 11.07 30.04 20.23 46.88 27.34 26.19 11.05 53.96 16.65 82.54 16.64v-60.61-22.49c.02.02-.22.02-.24.02z"/>
                    </g>
                  </svg>
                </a>
              </div>
          </div>
        </div>
    </Router>
    
    </div>
  );
}

function CurrentLink({name, to}) {
  const pathName = useLocation().pathname;

  if(pathName === to) {
    return (
      <Link to={to}><u>{name}</u></Link>
    );
  }else{
    return (
      <Link to={to}>{name}</Link>
    );
  }
  
}

function Home() {
  const styles = {
    background: `linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.10)), url(), url(${plants})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundClip: 'content-box',
  };

  return (
    <div id="home-div">
      <div id="home" style={styles}> 
        <div id="jordan-div">
          <img id="jordan" src={jordan}/>
        </div>
        
        <div id="headers">
          <h1>Jordan, D.C.</h1>
          <h2 className="chiropractic">Chiropractic</h2>
          <div id="jordan-quote">
            “I firmly believe chiropractic care can hold value through every stage of life, and to just about anyone who utilizes it properly.”
          </div>
        </div>
      </div>
      <div id="services-homepage">
          <h3>Services</h3>
          <div id="chiropractic">
            Chiropractic<br/>

            <svg id="chiropractic-svg" enableBackground="new 0 0 512.002 512.002" viewBox="0 0 512.002 512.002" xmlns="http://www.w3.org/2000/svg"><g>
              <path d="m110.436 82.463c.601 0 1.212-.073 1.821-.225l50.607-12.627c20.798-4.893 36.431-22.428 38.906-43.648l2.06-17.59c.481-4.114-2.463-7.839-6.577-8.321-4.09-.481-7.839 2.462-8.321 6.577l-2.06 17.593c-1.748 14.981-12.792 27.357-27.481 30.796-.035.008-.07.017-.105.026l-50.659 12.64c-4.02 1.003-6.464 5.074-5.462 9.093.851 3.409 3.908 5.686 7.271 5.686z"></path>
              <path d="m83.689 81.645c-1.002-4.019-5.071-6.467-9.093-5.461l-23.132 5.771c-30.301 7.57-51.463 34.667-51.463 65.896v28.34c0 15.908 3.338 31.732 9.602 46.309-.034.113 0 90.731-.012 90.891 0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-65.825c1.341 1.059 2.984 1.616 4.646 1.616 1.56 0 3.132-.484 4.478-1.488 3.32-2.477 4.005-7.175 1.528-10.496-13.054-17.503-20.242-39.169-20.242-61.006v-28.34c0-24.333 16.489-45.446 40.096-51.343l23.13-5.77c4.018-1.004 6.464-5.075 5.462-9.094z"></path>
              <path d="m24.42 348.258c-.074-4.142-3.479-7.429-7.633-7.366-4.142.074-7.438 3.491-7.365 7.632.278 15.633 2.008 31.331 5.141 46.658 3.107 15.213 2.252 31.066-2.476 45.848l-3.999 12.526c-5.261 16.453-7.982 33.577-8.087 50.899-.025 4.142 3.312 7.52 7.455 7.545h.046c4.12 0 7.474-3.328 7.499-7.455.096-15.8 2.576-31.418 7.375-46.425l3.999-12.526c5.507-17.22 6.505-35.691 2.884-53.417-2.949-14.427-4.577-29.205-4.839-43.919z"></path>
              <path d="m122.074 361.991c-5.326-23.232-8.03-47.09-8.039-70.908l-.001-81.523c0-4.142-3.358-7.5-7.5-7.5-4.143 0-7.5 3.358-7.5 7.5l.001 81.526c.006 15.99 1.178 31.996 3.483 47.835l-10.607 43.393c-6.014 25.249-9.062 51.199-9.062 77.13v45.056c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-45.056c0-24.763 2.912-49.543 8.644-73.612l2.92-11.945c.121.531 5.453 23.78 5.57 24.301 4.554 20.055 5.005 40.682 1.341 61.313l-7.736 43.691c-.723 4.079 1.998 7.971 6.077 8.693.442.078.882.116 1.316.116 3.569 0 6.732-2.558 7.376-6.194l7.736-43.688c4.016-22.609 3.517-45.236-1.478-67.229z"></path>
              <path d="m310.232 25.96c2.476 21.223 18.106 38.757 38.905 43.65l50.588 12.627c.609.152 1.221.225 1.822.225 3.361 0 6.42-2.276 7.271-5.686 1.004-4.019-1.441-8.09-5.46-9.093l-50.64-12.64c-.035-.009-.071-.018-.106-.026-14.689-3.439-25.733-15.815-27.481-30.799l-2.06-17.59c-.482-4.114-4.207-7.059-8.321-6.577s-7.059 4.208-6.577 8.321z"></path>
              <path d="m512.001 147.851c0-31.229-21.162-58.327-51.465-65.897l-23.21-5.79c-4.017-1.004-8.091 1.442-9.093 5.461s1.443 8.09 5.462 9.092l23.208 5.79c23.608 5.898 40.098 27.011 40.098 51.344v28.34c0 21.837-7.188 43.503-20.242 61.006-2.477 3.321-1.792 8.02 1.528 10.496 1.346 1.004 2.918 1.488 4.478 1.488 1.661 0 3.303-.557 4.644-1.614.007.417-.013 86.09.007 86.453.811 19.481-.761 39.046-4.669 58.152-3.627 17.722-2.631 36.196 2.879 53.424l4.004 12.523c4.792 14.987 7.272 30.607 7.372 46.428.026 4.126 3.379 7.453 7.499 7.453h.048c4.143-.026 7.479-3.405 7.453-7.547-.109-17.341-2.829-34.467-8.085-50.901l-4.004-12.524c-4.729-14.786-5.583-30.64-2.471-45.849 4.143-20.248 5.813-40.98 4.967-61.626-.011-.229.022-110.838-.011-111.047 6.265-14.579 9.604-30.405 9.604-46.315v-28.34z"></path>
              <path d="m152.706 290.599c1.374 0 2.764-.377 4.009-1.167 23.584-14.953 37.664-40.551 37.664-68.475v-62.4c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v62.4c0 22.758-11.475 43.62-30.695 55.807-3.499 2.218-4.536 6.852-2.318 10.35 1.427 2.253 3.857 3.485 6.34 3.485z"></path>
              <path d="m363.319 276.764c-19.22-12.187-30.694-33.049-30.694-55.807v-62.4c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v62.4c0 27.924 14.079 53.522 37.663 68.475 1.245.79 2.635 1.167 4.009 1.167 2.483 0 4.913-1.232 6.341-3.485 2.217-3.498 1.18-8.132-2.319-10.35z"></path>
              <path d="m409.484 338.921c2.305-15.84 3.477-31.846 3.483-47.838l.001-81.523c0-4.142-3.357-7.5-7.5-7.5-4.142 0-7.5 3.358-7.5 7.5l-.001 81.52c-.009 23.82-2.713 47.678-8.039 70.91l-7.438 32.449-.097.428c-5 22.017-5.499 44.645-1.483 67.25l7.736 43.691c.644 3.637 3.807 6.194 7.376 6.194.434 0 .874-.038 1.316-.116 4.079-.722 6.8-4.614 6.077-8.693l-7.736-43.695c-3.664-20.627-3.213-41.254 1.347-61.333l5.564-24.276 2.909 11.901c5.742 24.111 8.654 48.892 8.654 73.655v45.056c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-45.056c0-25.932-3.049-51.882-9.073-77.173z"></path>
              <path d="m326.158 328.418c-3.057 2.796-3.267 7.54-.471 10.596 15.917 17.396 24.684 39.99 24.684 63.617 0 52.036-42.334 94.37-94.37 94.37s-94.37-42.334-94.37-94.37 42.334-94.37 94.37-94.37c15.34 0 30.56 3.759 44.015 10.871 3.665 1.937 8.201.536 10.136-3.126 1.936-3.662.536-8.2-3.126-10.136-9.274-4.902-19.271-8.418-29.583-10.475l2.42-10.936c11.156-.436 20.098-9.647 20.098-20.909 0-11.538-9.387-20.925-20.925-20.925h-1.899l2.726-12.319c11.156-.436 20.098-9.647 20.098-20.909 0-11.538-9.387-20.925-20.925-20.925h-1.899l2.726-12.319c11.156-.436 20.098-9.647 20.098-20.908 0-11.538-9.387-20.925-20.925-20.925h-1.899l2.726-12.319c11.156-.436 20.098-9.647 20.098-20.909 0-11.538-9.387-20.925-20.925-20.925h-1.899l2.726-12.319c11.156-.436 20.098-9.647 20.098-20.909.01-11.652-9.595-21.103-21.242-20.925v-18.513c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v18.514h-15.434v-18.514c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v18.514c-11.647-.178-21.253 9.273-21.242 20.925 0 11.261 8.941 20.473 20.098 20.909l2.726 12.319h-1.899c-11.538 0-20.925 9.387-20.925 20.925 0 11.261 8.941 20.473 20.098 20.909l2.726 12.319h-1.899c-11.538 0-20.925 9.387-20.925 20.925 0 11.261 8.941 20.473 20.098 20.908l2.726 12.319h-1.899c-11.538 0-20.925 9.387-20.925 20.925 0 11.261 8.941 20.473 20.098 20.909l2.726 12.319h-1.899c-11.538 0-20.925 9.387-20.925 20.925 0 11.261 8.941 20.473 20.098 20.909l2.416 10.919c-50.073 9.996-87.925 54.285-87.925 107.253 0 60.307 49.063 109.37 109.37 109.37s109.37-49.063 109.37-109.37c0-27.385-10.163-53.574-28.617-73.743-2.798-3.058-7.543-3.268-10.597-.471zm-80.67-269.675c-.761-3.435-3.806-5.879-7.323-5.879h-5.198c-3.267 0-5.925-2.658-5.925-5.925s2.658-5.925 5.925-5.925h46.068c3.267 0 5.925 2.658 5.925 5.925s-2.658 5.925-5.925 5.925h-5.198c-3.518 0-6.562 2.445-7.323 5.879l-4.741 21.424h-11.543zm0 54.153c-.761-3.435-3.806-5.879-7.323-5.879h-5.198c-3.267 0-5.925-2.658-5.925-5.925s2.658-5.925 5.925-5.925h46.068c3.267 0 5.925 2.658 5.925 5.925s-2.658 5.925-5.925 5.925h-5.198c-3.518 0-6.562 2.445-7.323 5.879l-4.741 21.424h-11.543zm0 54.153c-.761-3.435-3.806-5.879-7.323-5.879h-5.198c-3.267 0-5.925-2.658-5.925-5.924 0-3.267 2.658-5.925 5.925-5.925h46.068c3.267 0 5.925 2.658 5.925 5.925s-2.658 5.924-5.925 5.924h-5.198c-3.518 0-6.562 2.445-7.323 5.879l-4.74 21.424h-11.544zm0 54.152c-.761-3.435-3.806-5.879-7.323-5.879h-5.198c-3.267 0-5.925-2.658-5.925-5.925s2.658-5.925 5.925-5.925h46.068c3.267 0 5.925 2.658 5.925 5.925s-2.658 5.925-5.925 5.925h-5.198c-3.518 0-6.562 2.445-7.323 5.879l-4.741 21.424h-11.543zm0 54.154c-.761-3.435-3.806-5.88-7.323-5.88h-5.198c-3.267 0-5.925-2.658-5.925-5.925s2.658-5.925 5.925-5.925h46.068c3.267 0 5.925 2.658 5.925 5.925s-2.658 5.925-5.925 5.925h-5.198c-3.518 0-6.562 2.445-7.323 5.879l-4.006 18.103c-2.165-.129-4.334-.197-6.506-.197-2.185 0-4.353.072-6.507.199z"></path>
              <path d="m237.373 464.967h37.256c4.143 0 7.5-3.358 7.5-7.5v-28.708h28.708c4.143 0 7.5-3.358 7.5-7.5v-37.256c0-4.142-3.357-7.5-7.5-7.5h-28.708v-28.708c0-4.142-3.357-7.5-7.5-7.5h-37.256c-4.143 0-7.5 3.358-7.5 7.5v28.708h-28.708c-4.143 0-7.5 3.358-7.5 7.5v37.256c0 4.142 3.357 7.5 7.5 7.5h28.708v28.708c0 4.142 3.358 7.5 7.5 7.5zm-28.708-51.208v-22.256h28.708c4.143 0 7.5-3.358 7.5-7.5v-28.708h22.256v28.708c0 4.142 3.357 7.5 7.5 7.5h28.708v22.256h-28.708c-4.143 0-7.5 3.358-7.5 7.5v28.708h-22.256v-28.708c0-4.142-3.357-7.5-7.5-7.5z"></path>
              </g>
            </svg>
          </div>
          <div id="e-stim">
            E-stim 

            <svg id="estim-svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g>
              <path d="m321.005 493.846c-29.641-13.974-60.913-29.214-88.8-45.956-3.553-2.132-8.158-.981-10.291 2.57-2.132 3.551-.981 8.158 2.57 10.291 28.453 17.082 60.131 32.521 90.124 46.663 3.77 1.778 8.227.136 9.982-3.586 1.766-3.746.162-8.215-3.585-9.982z"/>
              <path d="m205.696 430.753c-55.382-38.788-84.562-81.479-91.832-134.349-3.207-23.329-26.189-43.376-55.785-43.376h-50.579c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5c53.259.011 50.708-.026 52.417.031 17.24.58 36.573 12.105 39.088 30.388 4.224 30.717 15.161 57.944 33.439 83.239 15.825 21.901 36.972 41.97 64.646 61.354 3.394 2.376 8.069 1.552 10.446-1.841 2.377-3.392 1.553-8.069-1.84-10.446z"/>
              <path d="m471.692 104.321v-51.556c0-6.815-5.545-12.36-12.36-12.36h-147.088c-6.815 0-12.36 5.545-12.36 12.36v51.556c0 6.815 5.545 12.36 12.36 12.36h147.088c6.815 0 12.36-5.545 12.36-12.36zm-15-2.64h-141.808v-46.276h141.809v46.276z"/>
              <path d="m319.129 132.301c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h13.361c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5z"/>
              <path d="m452.446 132.301h-13.361c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h13.361c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5z"/>
              <path d="m333.08 84.729-1.841 2.44c-2.495 3.307-1.836 8.01 1.471 10.504 1.353 1.021 2.938 1.514 4.511 1.513 2.273 0 4.52-1.029 5.993-2.983l10.904-14.455c1.713-2.271 1.994-5.315.726-7.861s-3.868-4.155-6.713-4.155h-1.462l.251-.408c2.167-3.53 1.062-8.148-2.468-10.315-3.528-2.169-8.147-1.063-10.315 2.468l-7.264 11.832c-1.421 2.314-1.479 5.216-.153 7.586 1.296 2.314 3.717 3.769 6.36 3.834z"/>
              <path d="m385.788 86.042h46.745c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-46.745c-4.143 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z"/>
              <path d="m393.288 214.307v-7.422h36.71c9.934 0 18.016-8.082 18.016-18.016v-9.852h37.326c14.7 0 26.66-11.96 26.66-26.66v-121.829c0-14.701-11.96-26.661-26.66-26.661h-144.536c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h144.536c6.43 0 11.66 5.231 11.66 11.661v121.83c0 6.43-5.23 11.66-11.66 11.66-43.169 0-159.319 0-199.104 0-6.43 0-11.66-5.23-11.66-11.66v-121.83c0-6.43 5.23-11.661 11.66-11.661h24.58c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-24.58c-14.7 0-26.66 11.96-26.66 26.661v121.83c0 14.7 11.96 26.66 26.66 26.66h37.325v9.852c0 9.934 8.082 18.016 18.017 18.016h36.71v7.422c0 17.092-11.478 32.308-27.912 37.001l-98.859 28.241c-5.564-8.08-50.846-73.841-55.516-80.624-24.638-35.782-65.283-57.145-108.726-57.145h-79.775c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h79.775c38.506 0 74.533 18.935 96.371 50.65l22.662 32.912-37.398 38.539c-9.92 10.222-11.151 26.082-2.931 37.714l20.932 29.613c5.717 8.088 14.805 12.537 24.159 12.537 4.296 0 8.649-.939 12.756-2.895l46.7-22.244 79.819 115.922c2.35 3.411 7.018 4.273 10.431 1.923 3.412-2.349 4.273-7.019 1.925-10.43-9.905-14.385-92.285-134.027-102.207-148.438l43.245-12.354 10.896 19.462c11.313 20.208 32.729 32.762 55.889 32.762h23.753v27.072c0 8.233 6.698 14.932 14.931 14.932h36.544c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-36.475v-76.853h87.723v76.853h-21.262c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h21.33c8.233 0 14.932-6.698 14.932-14.932v-76.989c0-8.233-6.698-14.932-14.932-14.932h-87.861c-8.232 0-14.931 6.698-14.931 14.932v34.917h-23.753c-17.736 0-34.137-9.613-42.801-25.09l-9.164-16.368 35.937-10.266c22.841-6.523 38.793-27.669 38.793-51.423zm-54.726-25.437v-9.852h94.452v9.852c0 1.663-1.353 3.016-3.016 3.016h-88.42c-1.663-.001-3.016-1.353-3.016-3.016zm-121.186 153.439c-6.441 3.07-14.1 1.065-18.216-4.758l-20.931-29.613c-4.058-5.739-3.449-13.565 1.445-18.609l35.309-36.386 13.807 20.052 7.507 10.902-17.795 5.083c-3.982 1.138-6.289 5.289-5.151 9.272.941 3.294 3.944 5.441 7.208 5.441.682 0 1.376-.094 2.064-.29l22.651-6.471 16.638 24.164z"/></g>
            </svg>
          </div>
          <div id="cupping">
            Cupping
            <br/>
          <svg id="cupping-svg" enableBackground="new 0 0 64 64"  viewBox="0 0 64 64"  xmlns="http://www.w3.org/2000/svg">
            <path d="m8.966 57.644c.785.672 1.52 1.307 2.175 1.925-.085.805-.141 1.615-.141 2.431h2c0-2.534.451-5.022 1.341-7.394l3.8-10.132c.591-1.577.64-3.33.138-4.936l-4.324-13.836c-.147-.471-.615-.76-1.105-.69-.489.074-.85.494-.85.988v18.171c0 2.004.748 3.894 2.112 5.349l-1.644 4.384c-.405 1.08-.707 2.187-.945 3.305-.404-.355-.824-.715-1.256-1.085-2.231-1.91-4.759-4.074-5.758-6.417-.819-1.923-.702-4.346-.588-6.69.04-.821.079-1.626.079-2.396v-19.832c0-3.553 2.386-6.716 5.842-7.705l6.778-2.247c3.816-1.265 6.38-4.816 6.38-8.837h-2c0 3.157-2.013 5.945-5.01 6.939l-6.738 2.234c-4.27 1.221-7.252 5.174-7.252 9.616v19.833c0 .739-.038 1.512-.076 2.299-.125 2.569-.254 5.226.746 7.571 1.182 2.773 3.899 5.099 6.296 7.152zm5.034-13.473v-11.618l2.369 7.582c.37 1.184.334 2.475-.102 3.637l-1.336 3.564c-.606-.935-.931-2.024-.931-3.165z" />
            <path d="m59 37v-16.211c0-4.441-2.982-8.395-7.213-9.603l-6.777-2.247c-2.997-.994-5.01-3.782-5.01-6.939h-2c0 4.021 2.564 7.572 6.381 8.837l6.817 2.259c3.416.976 5.802 4.139 5.802 7.693v16.211z" />
            <path d="m31.554 33.486c-1.024-4.354-1.355-8.821-.984-13.278l.427-5.125-1.993-.166-.427 5.125c-.389 4.667-.042 9.344 1.03 13.902 1.547 6.574 1.499 13.512-.139 20.063l-.438 1.75 1.94.485.438-1.75c1.715-6.859 1.765-14.123.146-21.006z" />
            <path d="m59.5 57h-.5v-10c0-5.579-3.833-10.268-9-11.605v-3.395c0-.552-.448-1-1-1h-1v-2h-2v2h-1c-.552 0-1 .448-1 1v3.395c-5.167 1.337-9 6.026-9 11.605v10h-.5c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5h25c1.378 0 2.5-1.122 2.5-2.5s-1.122-2.5-2.5-2.5zm-13.5-24h2v2.051c-.33-.028-.662-.051-1-.051s-.669.023-1 .051zm0 4.051c.329-.033.662-.051 1-.051s.672.018 1.001.051v1.949h-2.001zm-9 9.949c0-4.469 2.947-8.262 7-9.539v1.539c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-1.539c4.053 1.277 7 5.07 7 9.539v10h-20zm22.5 13h-25c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.5 22 1.5c.276 0 .5.224.5.5s-.224.5-.5.5z" />
            <path d="m25.079 18.452-.832 1.818c.455.208.855.531 1.156.933l1.601-1.2c-.502-.669-1.168-1.205-1.925-1.551z" />
            <path d="m25.969 22.571c.02.141.031.285.031.429 0 .361-.063.714-.188 1.049l1.874.699c.208-.559.314-1.147.314-1.75 0-.24-.018-.476-.05-.707z" />
            <path d="m24.062 27.887c.814-.176 1.58-.56 2.212-1.107l-1.31-1.512c-.38.329-.838.559-1.326.665z" />
            <path d="m22.644 18.013c-.834.059-1.646.33-2.348.781l1.083 1.682c.42-.271.907-.433 1.407-.468z" />
            <path d="m18 22.999c0 .478.067.951.2 1.408l1.92-.562c-.08-.273-.12-.557-.12-.845 0-.503.126-1 .366-1.438l-1.755-.96c-.4.731-.611 1.561-.611 2.397z" />
            <path d="m19.464 26.535c.592.592 1.327 1.029 2.127 1.264l.563-1.919c-.479-.141-.919-.402-1.274-.758z" />
            <path d="m21.879 40.122-1.415 1.413c.592.592 1.327 1.029 2.127 1.264l.563-1.919c-.479-.141-.92-.403-1.275-.758z" />
            <path d="m29 37.998c0-.24-.018-.476-.05-.707l-1.98.28c.019.141.03.285.03.429 0 .361-.063.714-.188 1.049l1.874.699c.208-.559.314-1.147.314-1.75z" />
            <path d="m25.964 40.268c-.38.329-.838.559-1.326.665l.424 1.954c.814-.176 1.58-.56 2.212-1.107z" />
            <path d="m23.644 33.013c-.834.059-1.646.33-2.348.781l1.083 1.682c.42-.271.907-.433 1.407-.468z" />
            <path d="m21.12 38.845c-.08-.273-.12-.557-.12-.845 0-.503.126-1 .366-1.438l-1.755-.96c-.4.731-.611 1.56-.611 2.396 0 .478.067.951.2 1.408z" />
            <path d="m26.079 33.452-.832 1.818c.455.208.855.531 1.156.933l1.601-1.2c-.502-.669-1.168-1.205-1.925-1.551z" />
            <path d="m22.644 48.013c-.834.059-1.646.33-2.348.781l1.083 1.682c.42-.271.907-.433 1.407-.468z" />
            <path d="m22.153 55.879c-.479-.141-.919-.402-1.274-.758l-1.415 1.413c.592.592 1.327 1.029 2.127 1.264z" />
            <path d="m18 52.999c0 .478.067.951.2 1.408l1.92-.562c-.08-.273-.12-.557-.12-.845 0-.503.126-1 .366-1.438l-1.755-.96c-.4.731-.611 1.561-.611 2.397z" />
            <path d="m26.273 56.78-1.31-1.512c-.38.329-.838.559-1.326.665l.424 1.954c.815-.176 1.58-.559 2.212-1.107z" />
            <path d="m27.686 54.749c.208-.56.314-1.148.314-1.751 0-.24-.018-.476-.05-.707l-1.98.28c.019.141.03.285.03.429 0 .361-.063.714-.188 1.049z" />
            <path d="m25.403 51.203 1.601-1.2c-.501-.668-1.167-1.205-1.925-1.551l-.832 1.818c.455.209.855.531 1.156.933z" />
          </svg>
          
          </div>
          <div id="treatment-spiel">
            Conservative treatment should always be the first line of defense against health issues. 
            As a society we are too quick to turn to medication and surgery that doesn’t always resolve the problem. 
            Each treatment is unique to the patient, because every person, every body, every mind is very different. 
            Therefore, everyone’s healing is different. I shape my treatments to you as an individual, so that we can 
            work together to provide you with the most efficient and comfortable route to health.
            </div>
      </div>
    </div>
  );
}

function About() {

  return (
    <div id="about-div">
      <div id="about-content-div">
        <div id="biography">Biography</div>
        <div id="about-dr-jordan">About Dr. Jordan</div>
        <div id="intro">
          Dr. Jordan Abbass is a proud first generation chiropractor. He left his hometown, Carthage, New York, for Southern California in 2013 
          to pursue a career in chiropractic. When partaking in activities like tennis, pickleball, collegiate soccer, baseball and olympic lifting, stress 
          and injury are inevitable. After going through a handful of injuries himself, Dr. Abbass became inspired to help others through their struggles.
          “I learned the value of consistent chiropractic care when I was very little and hoped to share that with as many people as possible.”
          After finishing his undergraduate degree at Cypress College, Jordan attended Southern California University of Health Sciences in 2017, 
          graduating from Los Angeles College of Chiropractic in 2020 as a Doctor of Chiropractic.
        </div>
        <div id="chiro-care-quote">“I firmly believe chiropractic care can hold value through every stage of life, and to just about anyone who utilizes it properly.”</div>
        <img id="portrait-2" src={portrait2} />
        
      </div>
    </div>
    
  );
}

function Contact() {

  const center = 
                  {
                    lat: 33.83270526240601,   
                    lng: -118.18919219638732
                  }; 
  const zoom = 17;

  
  return (

    <div id="contact-div">
      <h2>Contact</h2>
      <div id="map-div">
        <Wrapper apiKey="AIzaSyBxX9-K0NWkss8P2C0-F6EOKMx5EoKusrk" render={render}>
          <MyMapComponent center={center} zoom={zoom} />
          
        </Wrapper>
      </div>
      <ContactForm />
      <div id="contact-text">
        4028 Long Beach Blvd Suite 202 Long Beach, CA 90807
      </div>
      
    </div>
  );
}

function ContactForm() {
  const form = useRef();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [firstNameMessage, setFirstNameMessage] = useState('');
  const [lastNameMessage, setLastNameMessage] = useState('');
  const [emailMessage, setEmailMessage] = useState('');
  const [phoneNumberMessage, setPhoneNumberMessage] = useState('');
  const [subjectMessage, setSubjectMessage] = useState('');
  const [messageMessage, setMessageMessage] = useState('');
  
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_azogljc', 'template_6jgdzfn', form.current, 'PBUqsspsL7YlBuQ4E')
    .then((result) => {
      console.log(result.text);
    }, (error) => {
      console.log(error.text);
    });
  };

  const checkNullValues = () => {
    let bool = true;

    if(firstName === '') {
      setFirstNameMessage('Please enter a first name');
      bool = false;
    } 
    if(lastName === '') {
      setLastNameMessage('Please enter a last name');
      bool = false;
    }
    if(emailIsValid(email) === false) {
      setEmailMessage('Please enter a valid email address');
      bool = false;
    }
    if(phoneNumber === '') {
      setPhoneNumberMessage('Please enter a phone number');
      bool = false;
    }
    if(subject === '') {
      setSubjectMessage('Please enter a subject');
      bool = false;
    }
    if(message === '') {
      setMessageMessage('Please enter a message');
      bool = false;
    }

    return bool;
  }

  const handleSubmit = (event) => {
    console.log(form.current);
    console.log(emailIsValid(email));
    
    if(checkNullValues() === true) {
      sendEmail(event);
      setFirstName('');
      setLastName('');
      setEmail('');
      setPhoneNumber('');
      setSubject('');
      setMessage('');
      return;
    }

    return;
  };

  const handleChange = (elem, event) => {
    switch(elem) {
      case 'firstName':
        setFirstName(event);
        if(firstNameMessage !== '') {
          setFirstNameMessage('');
        }
        break;
      case 'lastName':
        setLastName(event);
        if(lastNameMessage !== '') {
          setLastNameMessage('');
        }
        break;
      case 'email':
        setEmail(event);
        if(emailMessage !== '') {
          setEmailMessage('');
        }
        break;
      case 'phoneNumber':
        formatPhoneNumber(event);
        break;
      case 'subject':
        setSubject(event);
        if(subjectMessage !== '') {
          setSubjectMessage('');
        }
        break;
      case 'message':
        setMessage(event);
        if(messageMessage !== '') {
          setMessageMessage('');
        }
        break;
    }
  };

  const formatPhoneNumber = (event) => {
    const lastCharacter = event.substring(event.length - 1);
    if(phoneNumberMessage !== '') setPhoneNumberMessage('');
    if(!Number.isInteger(+event.replace(/([\(\)\ \-])+/g, '')) || ((lastCharacter === "("
      || lastCharacter === ")" || lastCharacter === "-" || lastCharacter === " ") && event.length === phoneNumber.length)) {
        setPhoneNumberMessage('Please only enter numbers');
      return;
    }
    if(event.length < 3) setPhoneNumber(event);

    if(event.length > phoneNumber.length) {
      if(event.length === 3) {
        event = '(' + event + ')';
      } else
      if(event.length === 5) {
        event = event + ' ';
      } else
      if(event.length === 6) {
        
        event = event.substring(0, event.length - 1) + ' ' + lastCharacter;
      } else
      if(event.length === 9) {
        event = event + ' - ';
      } else
      if(event.length === 10) {
        
        event = event.substring(0, event.length - 1) + ' - ' + lastCharacter;
      }
    } else {
      if(event.length <= 12 && event.length > 9) {
        event = event.substring(0, 9);
      } else
      if(event.length <= 6 && event.length > 4) {
        event = event.substring(0, 5);
      } else
      if(event.length <= 4 && event.length > 1) {
        event = event.slice(1, 3);
      }
    }
    
    setPhoneNumber(event);
  };

  const emailIsValid = (event) => {
    const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
    console.log(event.search(emailRegex));
    console.log(event);
    if(event.search(emailRegex) === 0) return true;
    return false;
  };

  return (
    <form ref={form} className="form">
      <div id="first-name-div">
        <label id="first-name">First Name</label><p class="input-message">{firstNameMessage}</p>
        
        <input
            name="first-name"
            type="text"
            value={firstName}
            onChange={(e) => handleChange('firstName', e.target.value)} />
      </div>
        
      <div id="last-name-div">
        <label id="last-name">Last Name</label><p class="input-message">{lastNameMessage}</p>
          <input
            name="last-name"
            type="text"
            value={lastName}
            onChange={(e) => handleChange('lastName', e.target.value)} />
      </div>
        
      <div id="email-div">
        <label id="email">Email</label><p class="input-message">{emailMessage}</p>
          <input
              name="email"
              type="text"
              value={email}
              onChange={(e) => handleChange('email', e.target.value)} />
      </div>
        
      <div id="phone-number-div">
        <label id="phone-number">Phone</label><p class="input-message">{phoneNumberMessage}</p>
          <input
              name="phone-number"
              type="tel"
              maxLength="16"
              value={phoneNumber}
              onChange={(e) => handleChange('phoneNumber', e.target.value)} />
      </div>
        
      <div id="subject-div">
        <label id="subject">Subject</label><p class="input-message">{subjectMessage}</p>
          <input
              name="subject"
              type="text"
              value={subject}
              onChange={(e) => handleChange('subject', e.target.value)}
              />
            
      </div>
      <div id="message-div">
        <label id="message">Message</label><p class="input-message">{messageMessage}</p>
        <textarea name="message" value={message} onChange={(e) => handleChange('message', e.target.value)}/>
      </div>  
      <input id="submit" type="button" value="Submit" onClick={(e) => handleSubmit(e)} />
      </form>
   );

}

async function initMarker(map) {
  const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
  const marker = new AdvancedMarkerElement({
    map,
    position: { 
      lat: 33.83186581581157, 
      lng: -118.18913282407898
    },
    
    title: "Jordan Abbass D.C.",
    
  });

  const contentString = `
  <div id="marker-label" class="details" style="overflow:visible;"> 
      <div id="jordan-address" class="address">Jordan Abbass D.C.</div>
      <div id="address">4028 Long Beach Blvd Suite 202</div>
      <div id="address-2">Long Beach, CA 90807</div>

      <div></div>
  </div>
  `;
  const infoWindow = await new window.google.maps.InfoWindow({
    content: contentString,
    ariaLabel: "Uluru",
    maxWidth: "230px"
  });


  
  marker.addListener( "click", () => {
    console.log("Listener");
    console.log(marker.content);

  });

  infoWindow.open({
    anchor: marker,
    map
  });
  return marker.content;

}

const render = (status) => {
  console.log(status);
  if (status === Status.SUCCESS) return <h3>Success</h3>;
  if (status === Status.FAILURE) return <h3>{status} ...</h3>;
  
  return null;
};

function Services() {

  return (
    <div id="service-div">
      <h4>Services</h4>
      <div id="chiropractic-services">
        <h5>Chiropractic</h5>
        <div id="chiropractic-text">
          Manual adjustments are a powerful tool utilized by Dr. Jordan Abbass. Correction of subluxations is the foundation of health in the chiropractic community. Nearly every nerve in the body stems from the spinal cord. Therefore, the health of your spine is essential for an optimally functioning nervous system. 
          <br/>
        </div>
        
        <img id="adjustment-img" src={adjustment}/>

      </div>
      <div id="e-stim-services">
        <h6>E-stim</h6>
        <div id="estim-text">
          E-stim or muscle stimulation is a tool utilized in conjunction with chiropractic to better assist in the healing process. E-stim uses electrical pulses to mimic the action of signals coming from neurons (cells in your nervous system). These mild electrical currents target either muscles or nerves. Muscle stimulation has been shown to reduce inflammation and edema. It gives the muscles in an area a nice, proper contraction and helps alleviate stiffness and pain. 
        </div>
        <img id="estim-img" src={estim}/>
      </div>
      <div id="cupping-services">
        <h7>Cupping</h7>
        <div id="cupping-text">
          Cupping is a powerful technique that focuses on drawing blood and/or nutrients to a particular area. Cupping leaves dark circles in an area that give us insight about blood stagnation. Cupping helps patients experience relief from pain and tightness.
        </div>
        <img id="cupping-img" src={cupping}/>
      </div>
    </div>
  );
}

function MyMapComponent({center, zoom}) {
  const ref = useRef();

  useEffect(() => {
    const map = new window.google.maps.Map(ref.current, {
      center,
      zoom,
      mapId: "a38d2e9736cf4524"
    });

    const AdvancedMarkerElement = initMarker(map);
    
  });

  return <div ref={ref} id="map" />;
}

export default App;
